import { F0Button } from '@factorialco/f0-react'

interface Props {
  buttonType: 'upgrade' | 'outline'
  handleOpenModal: () => void
  text: string
}

export const ActivationCenterButton = ({ buttonType, handleOpenModal, text }: Props) => {
  return <F0Button onClick={handleOpenModal} variant={buttonType} label={text} />
}
